/* eslint no-unused-expressions: 0 */
export const getPanDistance = (pin, isFeatured) => {
  let xDelta = 0;
  let yDelta = 0;
  let popupHeight = 160; // how close to top to check for non-featured popups
  let panYdist = 200; // how far to pan vertically for non-featured popups
  const halfPopupWidth = 135; // popups are all 270px wide

  // IE 11 FIX - IE 11 does not have .x and .y in pin object when balloon or star is clicked on map
  // but IE 11 does have clientX and clientY (as do all other browsers) so we'll use that for all balloons and stars.
  // and when a pin (non-star, non-balloon) is clicked on a map, Mapbox's pin object does NOT have
  // clientX or clientY on any browser. It just has .x and .y on all browsers.
  // so if our passed in pin object has clientX and clientY use that, otherwise, use x and y.
  const xKey = pin.clientX ? 'clientX' : 'x';
  const yKey = pin.clientY ? 'clientY' : 'y';

  // override for featured popups since they are taller popups
	// eslint-disable-next-line no-unused-expressions
  isFeatured === '1' && (
    popupHeight = 390,
    panYdist = 430,
    // override featured org panning for district map - it needs to pan the map MORE due to its extra filter row.
    window.location.pathname.indexOf('district') > -1 && (popupHeight = 430, panYdist = 470)
  );

  const leftListResults = document.getElementsByClassName('results-list')[0];

  // IE 11 FIX - IE 11 does NOT have an .x in its response to getBoundingClientRect(). It uses .width
  const objectWidthKey = !!window.MSInputMethodContext && !!document.documentMode ? 'width' : 'x';

  // checks to see if left search results are open or closed.
  leftListResults.closed = leftListResults.getBoundingClientRect()[objectWidthKey] < 0;

  const mapSize = document.getElementsByTagName('canvas')[0].getBoundingClientRect(); // gets map canvas size
  const leftRailWidth = leftListResults.closed ? 24 : leftListResults.offsetWidth;

  if (pin[xKey] < (140 + leftRailWidth)) { // if within 140 pixels to map's left edge or edge of list results
    xDelta = (pin[xKey] - leftRailWidth) - halfPopupWidth - 15; // pan map rightward (+), clicked x location less leftRailwidth less half of popup width less extra.
  }
  else if (pin[xKey] > (mapSize.width - 140)) { // if within 140 pixels to map's right edge
    xDelta = -(mapSize.width - pin[xKey] - halfPopupWidth - 15); // pan map leftward (-), map width less clicked x location less half of popup width less extra.
  }

  if (pin[yKey] < popupHeight) { // if clicked y location is closer to map top edge where featured popup would get cutoff.
    yDelta = -(panYdist - pin[yKey]); // pan map downward (-), the popup height less clicked y location, from top.
  }

  return [xDelta, yDelta];
}


export const getZoom = () => {
    const { innerWidth } = window;

    let zoom;

    if (innerWidth < 500) {
        zoom = 2;
    }
    else if (innerWidth < 1000) {
        zoom = 3;
    }
    else if (innerWidth < 1400) {
        zoom = 3.2;
    }
    else if (innerWidth < 1800) {
        zoom = 3.5;
    }
    else {
        zoom = 4;
    }

    return zoom;
};

export const getPadding = (isMobile) =>
    isMobile
        ? { top: 15, bottom: 40, right: 50 }
        : { top: 120, bottom: 40, left: 340, right: 150 };
